(function () {
  function normalizeColor(str) {
    return (str || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-\d+$/, '');
  }

  function altMatchesColor(altText, color) {
    if (!altText || !color) return false;
    var normalizedAlt = normalizeColor(altText);
    return (
      normalizedAlt === color ||
      normalizedAlt.indexOf(color + '-') === 0
    );
  }

  // --- Aspect ratio helpers (voorkomt inklappen bij "Automatisch" beeldverhouding) ---
  function getMediaRatio(mediaEl) {
    if (!mediaEl) return '';
    var ratio = '';
    try { ratio = (getComputedStyle(mediaEl).getPropertyValue('--ratio') || '').trim(); } catch (e) {}
    if (ratio && parseFloat(ratio) > 0) return parseFloat(ratio).toFixed(3);
    var img = mediaEl.querySelector('img');
    if (img) {
      if (img.naturalWidth && img.naturalHeight) {
        return (img.naturalWidth / img.naturalHeight).toFixed(3);
      }
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (w && h) return (w / h).toFixed(3);
    }
    return '';
  }
  function applyGalleryAspectRatio(gallery, mediaEl) {
    if (!gallery) return;
    var ratio = getMediaRatio(mediaEl);
    if (ratio) gallery.style.setProperty('--gallery-aspect-ratio', ratio);
  }
  function clearGalleryAspectRatio(gallery) {
    if (gallery) gallery.style.removeProperty('--gallery-aspect-ratio');
  }

  var currentColor = null;
  var pickerObservers = [];
  var galleryVisibleIndices = new WeakMap();
  var galleryObservers = new WeakMap();
  var galleryDebounceTimers = new WeakMap();
  var correctionInProgress = new WeakMap();
  var opacitySafetyTimer = null;

  // Touch state voor skip-guard
  var isUserTouching = false;
  document.addEventListener('touchstart', function () { isUserTouching = true; }, { passive: true });
  document.addEventListener('touchend', function () {
    setTimeout(function () { isUserTouching = false; }, 250);
  }, { passive: true });
  document.addEventListener('touchcancel', function () {
    setTimeout(function () { isUserTouching = false; }, 250);
  }, { passive: true });

  function detectCurrentColor() {
    var selectors = [
      'variant-picker input:checked',
      'swatches-variant-picker-component input:checked',
      'fieldset input[type="radio"]:checked',
      '[data-product-option] input:checked'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var input = document.querySelector(selectors[i]);
      if (input) {
        var val = input.value || input.getAttribute('data-option-value') || input.dataset.optionValue;
        if (val) return normalizeColor(val);
      }
    }
    var select = document.querySelector('variant-picker select, swatches-variant-picker-component select');
    if (select && select.value) return normalizeColor(select.value);
    return null;
  }

  function resetGalleryVisibility(gallery) {
    var containers = gallery.querySelectorAll('slideshow-slide, .product-media-container, [data-slide-index]');
    containers.forEach(function (el) {
      el.removeAttribute('hidden');
      el.hidden = false;
      el.style.removeProperty('display');
    });
    var thumbnails = document.querySelectorAll('[data-media-id-target], .product-media-thumbnail, [data-thumbnail-media-id]');
    thumbnails.forEach(function (thumb) {
      thumb.removeAttribute('hidden');
      thumb.hidden = false;
      thumb.style.removeProperty('display');
    });
  }

  // Safety net: zorgt dat gallery ALTIJD weer zichtbaar wordt na max 500ms
  function ensureGalleryVisible(gallery) {
    if (opacitySafetyTimer) clearTimeout(opacitySafetyTimer);
    opacitySafetyTimer = setTimeout(function () {
      if (gallery) {
        gallery.style.opacity = '1';
        gallery.style.removeProperty('opacity');
      }
    }, 500);
  }

  function startFilterTransition(gallery) {
    if (!gallery) return;
    gallery.style.transition = 'opacity 0.12s ease';
    gallery.style.opacity = '0';
    ensureGalleryVisible(gallery);
  }

  function finishFilterTransition(gallery) {
    if (!gallery) return;
    if (opacitySafetyTimer) clearTimeout(opacitySafetyTimer);
    setTimeout(function () {
      gallery.style.opacity = '1';
    }, 30);
  }

  function filterGallery(gallery, color) {
    if (!gallery) return false;
    resetGalleryVisibility(gallery);
    if (!color) {
      clearGalleryAspectRatio(gallery);
      finishFilterTransition(gallery);
      return true;
    }

    var mediaItems = Array.from(gallery.querySelectorAll('[data-media-id]'));
    if (mediaItems.length === 0) return false;

    var firstVisibleSlideIndex = -1;
    var visibleSlideIndices = [];
    var visibleMediaIds = [];
    var allSlides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    var matchCount = 0;
    var firstVisibleMediaEl = null;

    mediaItems.forEach(function (item) {
      var img = item.querySelector('img[alt]');
      var altText = img ? img.getAttribute('alt') : '';
      var matches = altMatchesColor(altText, color);
      var slide = item.closest('slideshow-slide, .product-media-container, [data-slide-index]') || item;

      if (matches) {
        matchCount++;
        if (!firstVisibleMediaEl) firstVisibleMediaEl = item;
        var mediaId = item.getAttribute('data-media-id');
        if (mediaId) visibleMediaIds.push(mediaId);
      } else {
        slide.hidden = true;
        slide.setAttribute('hidden', '');
      }
    });

    if (matchCount === 0) {
      resetGalleryVisibility(gallery);
      clearGalleryAspectRatio(gallery);
      finishFilterTransition(gallery);
      return true;
    }

    // Reserveer de hoogte van de gallery op basis van de eerste zichtbare
    // variant-afbeelding, zodat de carousel niet inklapt in "Automatisch" modus.
    applyGalleryAspectRatio(gallery, firstVisibleMediaEl);

    allSlides.forEach(function (slide, i) {
      if (!slide.hasAttribute('hidden')) {
        visibleSlideIndices.push(i);
        if (firstVisibleSlideIndex === -1) firstVisibleSlideIndex = i;
      }
    });

    var thumbnails = document.querySelectorAll('[data-media-id-target], .product-media-thumbnail, [data-thumbnail-media-id]');
    thumbnails.forEach(function (thumb) {
      var thumbMediaId =
        thumb.getAttribute('data-media-id-target') ||
        thumb.getAttribute('data-thumbnail-media-id') ||
        (thumb.querySelector('[data-media-id]') ? thumb.querySelector('[data-media-id]').getAttribute('data-media-id') : null);
      if (thumbMediaId && visibleMediaIds.length > 0 && visibleMediaIds.indexOf(thumbMediaId) === -1) {
        thumb.hidden = true;
        thumb.setAttribute('hidden', '');
      }
    });

    galleryVisibleIndices.set(gallery, visibleSlideIndices);

    if (firstVisibleSlideIndex !== -1 && allSlides.length > 0) {
      var slideshow = gallery.slideshow || (gallery.refs && gallery.refs.slideshow);
      if (slideshow && typeof slideshow.select === 'function') {
        try { slideshow.select(firstVisibleSlideIndex, undefined, { animate: false }); } catch (e) {}
      }
    }

    setupSkipGuard(gallery, allSlides);
    finishFilterTransition(gallery);
    return true;
  }

  function setupSkipGuard(gallery, allSlides) {
    var oldObserver = galleryObservers.get(gallery);
    if (oldObserver) oldObserver.disconnect();
    if (allSlides.length === 0) return;
    var slideshow = gallery.slideshow || (gallery.refs && gallery.refs.slideshow);

    var observer = new MutationObserver(function () {
      if (correctionInProgress.get(gallery)) return;
      var existingTimer = galleryDebounceTimers.get(gallery);
      if (existingTimer) clearTimeout(existingTimer);

      var timer = setTimeout(function () {
        if (isUserTouching) {
          var retryTimer = setTimeout(function () {
            if (!isUserTouching) checkAndSkip();
          }, 500);
          galleryDebounceTimers.set(gallery, retryTimer);
          return;
        }
        checkAndSkip();
      }, 400);
      galleryDebounceTimers.set(gallery, timer);

      function checkAndSkip() {
        var visibleIndices = galleryVisibleIndices.get(gallery) || [];
        if (visibleIndices.length === 0) return;

        var ariaVisibleIndices = [];
        for (var i = 0; i < allSlides.length; i++) {
          if (allSlides[i].getAttribute('aria-hidden') === 'false') {
            ariaVisibleIndices.push(i);
          }
        }
        if (ariaVisibleIndices.length === 0) return;

        var anyValid = ariaVisibleIndices.some(function (idx) {
          return visibleIndices.indexOf(idx) !== -1;
        });
        if (anyValid) return;

        var activeIndex = ariaVisibleIndices[0];
        var target = -1;
        for (var j = 0; j < visibleIndices.length; j++) {
          if (visibleIndices[j] > activeIndex) { target = visibleIndices[j]; break; }
        }
        if (target === -1) target = visibleIndices[0];

        correctionInProgress.set(gallery, true);
        if (slideshow && typeof slideshow.select === 'function') {
          try { slideshow.select(target, undefined, { animate: false }); } catch (e) {}
        }
        setTimeout(function () { correctionInProgress.set(gallery, false); }, 100);
      }
    });

    allSlides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
    galleryObservers.set(gallery, observer);
  }

  function applyFilter(attempt) {
    attempt = attempt || 0;
    if (!currentColor) {
      var detected = detectCurrentColor();
      if (detected) currentColor = detected;
    }
    if (!currentColor) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) {
      if (attempt < 5) setTimeout(function () { applyFilter(attempt + 1); }, 100);
      return;
    }
    if (attempt === 0) startFilterTransition(gallery);
    var success = filterGallery(gallery, currentColor);
    if (!success && attempt < 5) {
      setTimeout(function () { applyFilter(attempt + 1); }, 100);
    } else if (!success) {
      // Geef het op, maar zorg dat gallery zichtbaar blijft
      gallery.style.opacity = '1';
    }
  }

  function checkAndRefilter() {
    var detected = detectCurrentColor();
    if (detected && detected !== currentColor) {
      currentColor = detected;
      applyFilter(0);
    }
  }

  function setupPickerObservers() {
    pickerObservers.forEach(function (o) { o.disconnect(); });
    pickerObservers = [];
    var pickers = document.querySelectorAll(
      'variant-picker, swatches-variant-picker-component, [data-product-option]'
    );
    pickers.forEach(function (picker) {
      var observer = new MutationObserver(function () {
        setTimeout(checkAndRefilter, 50);
      });
      observer.observe(picker, {
        attributes: true,
        subtree: true,
        attributeFilter: ['checked', 'data-current-checked', 'aria-checked', 'selected', 'data-selected']
      });
      pickerObservers.push(observer);
    });
  }

  var bodyObserver = new MutationObserver(function (mutations) {
    var needsFilter = false;
    var needsRebindPickers = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node.tagName) continue;
        var tag = node.tagName.toLowerCase();
        if (tag === 'media-gallery' || (node.querySelector && node.querySelector('media-gallery'))) {
          needsFilter = true;
        }
        if (
          tag === 'variant-picker' || tag === 'swatches-variant-picker-component' ||
          (node.querySelector && node.querySelector('variant-picker, swatches-variant-picker-component'))
        ) {
          needsRebindPickers = true;
        }
      }
    }
    if (needsRebindPickers) setTimeout(setupPickerObservers, 50);
    if (needsFilter) setTimeout(function () { applyFilter(0); }, 50);
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  function handleVariantInteraction(e) {
    if (!e.target) return;
    var picker = e.target.closest && e.target.closest(
      'variant-picker, swatches-variant-picker-component, [data-product-option]'
    );
    if (!picker) return;
    setTimeout(checkAndRefilter, 50);
  }
  document.addEventListener('change', handleVariantInteraction);
  document.addEventListener('input', handleVariantInteraction);
  document.addEventListener('click', handleVariantInteraction);

  ['variant:update', 'variantupdate', 'theme:variant:update', 'variantUpdate'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(checkAndRefilter, 50);
    });
  });

  setInterval(checkAndRefilter, 400);

  function init() {
    setupPickerObservers();
    var detected = detectCurrentColor();
    if (detected) {
      currentColor = detected;
      applyFilter(0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();